'use client'
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic'
import React, { useState, useEffect,useLayoutEffect } from 'react'

import Navbar from '../../components/Layouts/Navbar';
import Content from '../../components/ReportProfile/Content';
import ExploreAsco from '../../components/ReportProfile/SideBar/ExploreAsco';

const Footer = dynamic(() => import('../../components/Layouts/Footer', { ssr: false }));
const Breadcrumb = dynamic(() => import('../../components/Layouts/Breadcrumb', { ssr: false }));
const Prices = dynamic(() => import('../../components/ReportProfile/SideBar/Prices', { ssr: false }));
const SupportCard = dynamic(() => import('../../components/PressRelease/SupportCard', { ssr: false }));
const RecentlyViewedProducts = dynamic(() => import('../../components/ReportProfile/SideBar/RecentlyViewedProducts', { ssr: false }));
const Subscription = dynamic(() => import('../../components/ReportProfile/SideBar/Subscription', { ssr: false }));
const Customize = dynamic(() => import('../../components/ReportProfile/SideBar/Customize', { ssr: false }));
const ExitIntent = dynamic(() => import('../../components/Common/ExitIntentForm', { ssr: false }));
const RandomPressrelease = dynamic(() => import('../../components/ReportProfile/SideBar/RandomPressrelease', { ssr: false }));
const InfographicsDownload = dynamic(() => import('../../components/ReportProfile/SideBar/InfographicsDownload', { ssr: false }));
const SideBarPopup = dynamic(() => import('../../components/ReportProfile/SideBar/SiderBarPopup', { ssr: false }));


export default function Main({reportData}) {

    const router = useRouter();
    const [reportdata, setReportData] = useState([])
    const [scrolled, setScrolled] = useState(0)
    const [scrolledStatus, setScrolledStatus] = useState(false)

    useLayoutEffect(() => {
        if ((reportData?.report_data) != null) {
            setReportData(reportData)
        }
        else {
            router.push('/404')
        }

    }, [reportData, router])


    useEffect(() => {
        
        const onScroll = () => setScrolled(window.pageYOffset);
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);


    useEffect(() => {
        if (scrolled > 20) {
            setScrolledStatus(true)
        }
    }, [scrolled])

  return (
    <>
        <Navbar className="z-0" />
                <div className='mt-65'>
                    <Breadcrumb />
                </div>
                {/* {(reportdata?.report_data) &&
                    <ExitIntent
                        product_name={reportdata?.report_data?.name}
                        title={reportdata?.report_data?.h1_title ? reportdata?.report_data?.h1_title : (reportdata?.report_data?.slug)?.replace(/-/g, ' ') + ' ' + 'Sample Page'}
                        shortDescription={'Get a Sneak Peek at the Latest' + ' ' + (reportdata?.report_data?.slug)?.replace(/-/g, ' ') + ' ' + 'Report'}
                        page_name="Exit Intent Report Profile"
                        form_name="exit-intent-report-profile"
                        slug={reportdata?.report_data?.slug}
                    />
                } */}
                <div className="z-50 flex flex-col justify-center w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-4">
                    <div className='grid grid-cols-12 gap-4'>
                        <div className='col-span-12 lg:col-span-8 xl:col-span-9'>
                            {(reportdata?.report_data) ?
                                <Content data={reportdata} />
                                :
                                <>
                                    <div role="status" className="w-full animate-pulse ">
                                        <div className='grid grid-cols-12 gap-1'>
                                            <div className="col-span-2 p-1">
                                                <div className="h-[120px] bg-gray-200 rounded-md dark:bg-gray-700 w-full mb-4"></div>
                                            </div>
                                            <div className="col-span-10 p-1">
                                                <div className="h-4 m-1 bg-gray-200 w-full rounded-md dark:bg-gray-700  mb-2.5"></div>
                                                <div className="h-4 m-1 bg-gray-200 rounded-md dark:bg-gray-700 w-80 mb-2.5"></div>
                                                <div className="h-4 m-1 bg-gray-200 rounded-md dark:bg-gray-700 w-20 mb-2.5"></div>
                                                <div className="h-4 m-1 bg-gray-200 rounded-md dark:bg-gray-700 w-40 mb-2.5"></div>
                                            </div>
                                            <div className="col-span-12 p-1">
                                                <div className="h-[820px] bg-gray-200 rounded-md dark:bg-gray-700 w-full mb-4"></div>
                                            </div>
                                        </div>
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </>

                            }

                        </div>
                        <div className='z-30 col-span-12 lg:col-span-4 xl:col-span-3'>
                            <Prices data={reportdata ? reportdata : []} />
                            <Customize sampleSlug={reportdata?.report_data} />
                            {scrolledStatus &&
                                <>
                                    <RecentlyViewedProducts />
                                    {reportdata?.report_data?.therapeutic_areas[0]?.value==="Oncology" ? <ExploreAsco />: null}

                                    <SupportCard />
                                    <InfographicsDownload data={reportdata?.Infographics_data} />
                                    <Subscription />
                                    <RandomPressrelease />
                                    <SideBarPopup sampleSlug={reportdata?.report_data} />
                                </>
                            }
                        </div>
                    </div>
                </div>
                {scrolledStatus &&
                <Footer />
                }
    </>
  )
}